import miteePrototype from './mitee-prototype.vue';



// 为组件添加 install 方法，用于按需引入
miteePrototype.install = function (Vue) {
    Vue.component(miteePrototype.name, miteePrototype)
}




export default miteePrototype